import * as React from "react";
import MuiGrow from "@mui/material/Grow";
import { GrowProps as MuiGrowProps } from "@mui/material/Grow";

export interface GrowProps extends MuiGrowProps {}

export const Grow: React.FC<GrowProps> = MuiGrow;
